<template>
	<div class="custom-table" :class="{'flex-column': height == 'grow', 'flex-grow': height == 'grow'}">
		<div class="custom-table-operate flex">
			<m-operate>
				<slot name="operate"></slot>
				<template #right>
					<slot name="otherOperate"></slot>
				</template>
			</m-operate>
			<m-operate>
				<template #right>
					<c-button prepend-icon="tf-field-config" @click="globalDialog('fieldConfig', {props: {viewId: viewId}}, updateColumn)">字段配置</c-button>
				</template>
			</m-operate>
		</div>

		<c-table ref="list" border :height="height" :paging="paging" width-resize @widthResize="widthResizeHandle">
			<template v-if="$scopedSlots.empty" #empty>
				<slot name="empty"></slot>
			</template>
			
			<c-table-column v-if="drag"
				type="drag"
			></c-table-column>
			
			<c-table-column v-if="selector"
				type="selector"
				width="32"
			></c-table-column>

			<c-table-column v-if="readonly"
				width="32"
				:width-resize="false"
				fixed-width
				fixed="left"
				:ellipsis="false"
				:summed="summedRow"
			>
				<template #default="{index}">
					<p style="margin: 0 -5px; text-align: center; word-break: break-all;">{{index + 1}}</p>
				</template>

				<template #summed>
					<div class="flex-center" style="height: 10px; margin: 0 -5px;">
						<p style="line-height: 14px; font-size: 11px; text-align: center;">合计</p>
					</div>
				</template>
			</c-table-column>

			<slot></slot>
			
			<template v-for="(col, i) in columnList">
				<template v-if="col.is_display == 1">
					<c-table-column
						v-if="!col.is_custom"
						:key="col.field_code"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
						:summed="readonly && summed && col.field_type == 2 && col.is_summed == 1 ? ({data}) => {return parseFloat(data[col.field_code]) || 0} : false"
					>
						<template v-if="$scopedSlots[col.field_code]" #default="{data, nodeData, update, remove}">
							<slot :name="col.field_code" :data="data" :nodeData="nodeData" :update="update" :remove="remove"></slot>
						</template>

						<template v-if="$scopedSlots[`${col.field_code}_tip`]" #tip>
							<slot :name="`${col.field_code}_tip`"></slot>
						</template>

						<template v-if="$scopedSlots[`${col.field_code}_summed`]" #summed="{total}">
							<slot :name="`${col.field_code}_summed`" :total="parseFloat(total.toFixed(6))"></slot>
						</template>
						<template v-else-if="$scopedSlots[col.field_code]" #summed="{total}">
							<slot :name="col.field_code" :data="{[col.field_code]: parseFloat(total.toFixed(6))}"></slot>
						</template>
						<template v-else #summed="{total}">
							<span>{{parseFloat(total.toFixed(6))}}</span>
						</template>
					</c-table-column>

					<c-table-column
						v-else
						:key="col.field_code"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
						:required="col.config_json.attr.includes('required')"
						:summed="readonly && summed && col.config_json.type == 'number'"
					>
						<template v-if="readonly" #default="{data}">
							<div v-if="['file', 'image'].includes(customConfig[col.field_code].type)" class="flex-wrap file-list">
								<template v-if="data.custom_fields_value_json[col.field_code]">
									<template v-if="typeof data.custom_fields_value_json[col.field_code] == 'string'">
										<c-file v-for="(file, i) in data.custom_fields_value_json[col.field_code].split(',')" :key="i" :src="file" media :preview="data.custom_fields_value_json[col.field_code].split(',')"></c-file>
									</template>
									<template v-else>
										<c-file v-for="(file, i) in data.custom_fields_value_json[col.field_code]" :key="i" :src="file" media :preview="data.custom_fields_value_json[col.field_code]"></c-file>
									</template>
								</template>
							</div>
							<c-tags v-else-if="typeof data.custom_fields_value_json[col.field_code] == 'object'" :value="data.custom_fields_value_json[col.field_code]"></c-tags>
							<span v-else>{{data.custom_fields_value_json[col.field_code] || '-'}}</span>
						</template>
						
						<template v-else #default="{data}">
							<c-input v-if="customConfig[col.field_code].type == 'text'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-input>

							<c-input v-else-if="customConfig[col.field_code].type == 'number'"
								v-model="data.custom_fields_value_json[col.field_code]"
								type="number"
								:decimal="customConfig[col.field_code].attr.includes('decimal') ? customConfig[col.field_code].decimal : 0"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-input>

							<c-datetime v-else-if="customConfig[col.field_code].type == 'time'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:type="customConfig[col.field_code].format.split('|')[1]"
								:format="customConfig[col.field_code].format.split('|')[0]"
								:time-accuracy="customConfig[col.field_code].format.split('|')[2]"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-datetime>

							<c-select v-else-if="customConfig[col.field_code].type == 'option'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:options="customConfig[col.field_code].options"
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
								:search="{add: customConfig[col.field_code].attr.includes('add')}"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
								@add="addCustomOption(col, arguments[0], arguments[1], arguments[2])"
							></c-select>

							<c-upload-file v-else-if="customConfig[col.field_code].type == 'file'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:type="customConfig[col.field_code].suffix.join(',')"
								media
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								media-icon="tf-plus"
								:sort="false"
								:button="false"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-upload-file>

							<c-upload-file v-else-if="customConfig[col.field_code].type == 'image'"
								v-model="data.custom_fields_value_json[col.field_code]"
								type="image"
								media
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								media-icon="tf-plus"
								:sort="false"
								:button="false"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-upload-file>
						</template>

						<template v-if="col.config_json.tip" #tip>
							<c-tooltip align="end" :tip="col.config_json.tip"></c-tooltip>
						</template>
						
						<template #summed="{total}">
							<span>{{parseFloat(total.toFixed(6))}}</span>
						</template>
					</c-table-column>
				</template>
			</template>
		</c-table>
	</div>
</template>

<script>
	export default {
		name: 'customTable',

		props: {
			workType: [String, Number],
			viewId: [String, Number],
			border: {
				type: Boolean,
				default: true
			},
			paging: Boolean,
			drag: Boolean,
			selector: Boolean,
			readonly: Boolean,
			summed: {
				type: Boolean,
				default: true
			},
			height: {
				type: [String, Number],
				default: 'auto'
			}
		},

		data() {
			return {
				customConfig: {},
				columnList: []
			}
		},

		computed: {
			required() {
				let list = [];
				this.columnList.forEach(item => {
					if (item.is_custom == 1 && item.config_json.attr.includes('required')) {
						list.push(item.field_code);
					}
				});
				return list;
			},

			defaultData() {
				let data = {}, object = false;
				this.columnList.map(item => {
					if (item.is_custom == 1 && item.config_json.default) {
						if (item.config_json.default.type == 1) {
							if (item.config_json.type == 'time') {
								data[item.field_code] = new Date().format(item.config_json.format.split('|')[0]);
							} else {
								data[item.field_code] = item.config_json.default.value;
							}
						} else if (item.config_json.default.type == 2) {
							object = true;
						}
					}
				})

				return {
					data,
					object
				}
			},

			summedRow() {
				return this.summed && !!this.columnList.find(col => col.is_display == 1 && (col.is_custom ? col.config_json.type == 'number' : (col.field_type == 2 && col.is_summed == 1)));
			}
		},

		mounted() {
			this._setTableData = this.$refs.list.setData;
			this.$refs.list.setData = list => {
				list.forEach(item => item.custom_fields_value_json = item.custom_fields_value_json || {});
				this._setTableData(list);
			}
			this._pushTableData = this.$refs.list.push;
			this.$refs.list.push = list => {
				this._pushTableData(list);
			}
			this.pasteParse();
		},

		methods: {
			init() {
				!this.paging && this._setTableData([]);
				this.updateColumn();
			},

			updateColumn() {
				this.request({
					url: '/sys_user_view/field_list',
					data: {
						view_id: this.viewId
					},
					success: data => {
						let config = {};
						data.field_list.forEach(item => {
							if (item.is_custom) {
								config[item.field_code] = item.config_json;
							}
						});
						this.customConfig = config;
						this.columnList = [];
						this.$nextTick(() => {
							this.columnList = data.field_list;

							if (this._defaultQueue) {
								this.$nextTick(() => {
									this._defaultQueue.forEach(item => {
										item();
									});
									delete this._defaultQueue;
								});
							}
						});
					}
				});
			},

			setDefaultData(target, source) {
				return new Promise(resolve => {
					let handler = () => {
						let single = false;
						if (!Array.isArray(target) && typeof target == 'object') {
							single = true;
							target = [target];
						}

						if (this.defaultData.object && source) {
							this.request({
								url: '/sys_field/default/values',
								data: source,
								loading: !single,
								success: data => {
									if (typeof target == 'function') {
										resolve(target(data.map(item => Object.assign(item, this.defaultData.data))));
									} else {
										target.forEach((item, index) => item.custom_fields_value_json = Object.assign(data[index], this.defaultData.data, item.custom_fields_value_json));
										resolve(single ? target[0] : target);
									}
								}
							})
						} else {
							if (typeof target == 'function') {
								resolve(target(source.source_list.map(() => Object.assign({}, this.defaultData.data))));
							} else {
								target.forEach(item => item.custom_fields_value_json = Object.assign({}, this.defaultData.data, item.custom_fields_value_json));
								resolve(single ? target[0] : target);
							}
						}
					}
					
					if (!this.columnList.length) {
						if (!this._defaultQueue) {
							this._defaultQueue = [];
						}
						this._defaultQueue.push(handler);
					} else {
						handler();
					}
				});
			},

			validate() {
				let row = this.$refs.list.getData().find(row => {
					return this.required.find(item => {
						return !row.custom_fields_value_json[item] && row.custom_fields_value_json[item] !== 0;
					})
				})
				return row ? '请完善带星号的必填字段' : true;
			},

			widthResizeHandle(col) {
				let item = this.columnList.find(item => item.field_code == col.name);
				if (item) {
					item.width = col.width;
					this.request({
						url: '/sys_user_view/edit_field',
						data: {
							view_id: this.viewId,
							field_list: this.columnList.map(item => {
								return {
									field_id: item.field_id,
									width: item.width,
									is_display: item.is_display,
									is_lock: item.is_lock
								}
							})
						}
					})
				}
			},

			pasteParse() {
				let that = this;
				['.c-input input', '.c-input textarea', '.c-datetime input'].forEach(selector => {
					$(this.$refs.list.$el).on('focus', selector, function() {
						that._pasteParseHandle = e => {
							let paste = e.clipboardData.getData('text/html').match(/<td[^>]*>(?:(?!<\/tb>).)*<\/td>/g);
							if (!paste) return;
							e.preventDefault();
							let colIndex = $(this).closest('td').index();
							let $row = $(this).closest('tr').nextAll('tr');
							paste.forEach((item, index) => {
								let input = index ? $row.eq(index - 1).find('td').eq(colIndex).find(selector).get(0) : this;
								if (input) {
									try {
										input.value = item.match(/<td[^>]*>((?:(?!<\/tb>).)*)<\/td>/)[1].replaceAll('<br>', '\n').replace(/<[^>]*>/g, '').trim();
										input.dispatchEvent(new Event('input', {bubbles: true}));
										input.dispatchEvent(new Event('change', {bubbles: true}));
									} catch(e) {}
								}
							});
						};
						document.addEventListener('paste', that._pasteParseHandle);
					});
					$(this.$refs.list.$el).on('blur', selector, function() {
						document.removeEventListener('paste', that._pasteParseHandle);
						delete that._pasteParseHandle;
					});
				});
			},

			addCustomOption(item, event, name, resolve) {
				let option = {
					name,
					value: name
				}
				this.request({
					url: '/sys_field/edit',
					data: {
						work_type_id: this.workType,
						id: item.field_id,
						field_title: item.field_title,
						config_json: JSON.stringify(Object.assign({}, item.config_json, {
							options: item.config_json.options.map(item => item).concat([option])
						}))
					},
					loading: true,
					success: () => {
						resolve(option);
						this.updateColumn();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.custom-table {
		&-operate {
			>>> .m-operate {
				&[empty] + .m-operate,
				&:nth-child(1) {
					flex-grow: 1;
					width: 0;
					border-left-width: 1px;
				}

				&:nth-child(2) {
					padding-left: 8px;

					^[-2] ^[-1..-1] {
						border-right-width: 1px;
					}
				}

				&:nth-last-child(2) {
					padding-right: 0;
					border-right-width: 0;
				}
			}
		}

		>>> .c-upload-media-item,
		>>> .c-file-media {
			min-width: 32px;
			width: 32px;
			height: 32px;
			font-size: 20px;
		}

		>>> .c-upload-handle {
			display: none;
		}

		.file-list {
			gap: 6px;

			>>> .c-file-media {
				width: 32px;
				height: 32px;
			}
		}
	}
</style>
